module.exports = ".login-page {\r\n  overflow: hidden;\r\n  min-height: 100%;\r\n}\r\n"